export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-5.c15652dd.png";